import script from "./HelpView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpView.vue?vue&type=script&setup=true&lang=ts"

import "./HelpView.vue?vue&type=style&index=0&id=0653311e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0653311e"]])

export default __exports__